import angular from 'angular';

angular.module('cloudX').directive('limitDigits', [
  '$parse',
  function($parse) {
    var directive = {
      restrict: 'A',
      require: ['ngModel'],
      link: link,
      priority: 2, //After percentageDrv
    };
    return directive;

    function link(scope, element, attr, ctrls) {
      var ngModelController = ctrls[0];
      ngModelController.$parsers.push(function(viewValue) {
        if (typeof viewValue === 'undefined' || viewValue === null || isNaN(viewValue))
          return viewValue;
        var value = viewValue.trunc(attr.limitDigits);
        if (value !== viewValue.round(10)) {
          var formatters = ngModelController.$formatters,
            idx = formatters.length;
          var newViewValue = value;
          while (idx--) {
            newViewValue = formatters[idx](newViewValue);
          }
          ngModelController.$setViewValue(newViewValue);
          ngModelController.$render();
        }
        return value;
      });
    }
  },
]);
